import React, { ReactNode } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import styled from 'styled-components';

export const CenteredLoader = () => (
  <CenteredLoaderStyled>
    <Loader active={true} />
  </CenteredLoaderStyled>
);

type Props = {
  children?: ReactNode;
};

export const LoaderWithDimmer: React.FC<Props> = ({ children }) => (
  <LoaderWithDimmerStyled>
    <Dimmer active={true} inverted={true}>
      <div>
        <Loader size="large" inverted={true}>
          Loading
        </Loader>
        <p>{children}</p>
      </div>
    </Dimmer>
  </LoaderWithDimmerStyled>
);

const LoaderWithDimmerStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 105;

  .text.loader {
    font-size: 14px !important;
  }

  p {
    margin-top: 170px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 1.6em;
  }
`;

const CenteredLoaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
